import { CSSObject, MantineTheme } from '@mantine/core';
import { MantineThemeComponent } from '../../types';
import { textVariants } from '../../tokens/typography/typography';

const InputDefaultConfig: MantineThemeComponent = {
	defaultProps: {},
	styles: ( theme: MantineTheme ) => ( {
		input: {
			background: theme.fn.themeColor( 'gray.0' ),
			...( textVariants.footnote as CSSObject )
		},
		placeholder: {
			...( textVariants.footnote as CSSObject ),
			color: `${theme.fn.themeColor( 'dark.2' )} !important`
		},
		icon: {
			color: theme.fn.themeColor( 'dark.2' )
		}
	} )
};

export default InputDefaultConfig;
